var React = require('react');

function MS (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.12 65.040l0.48-0.24-0.56 0.24h0.080zM41.28 64.8l-0.64-0.080 0.16 0.32zM34 64.56v-0.16l-1.040 0.32 0.72 0.4zM40 64.8l-1.76-0.4h-0.72v0.16zM42 0.56l-21.68-0.24 0.4 1.2-2 1.28-0.4 1.28-0.88 0.080-0.32 4-1.040 0.64h-0.96l-0.16 1.12h-0.4l-0.72 1.040-0.8 0.72 0.72 1.28-2.48 0.88 0.56 0.88-0.24 0.64 0.16 0.96-2.080 1.76 0.88 0.48-0.24 0.8-0.64 0.16 1.2 1.36-0.8 2 0.8 0.56 0.32 1.52-0.96 0.72v1.68l1.040 0.72-1.040 2.080 0.96 0.96-1.12 0.8 0.8 1.040-0.24 1.36 2.4 2-1.52 2.32-0.88 0.16 0.24 1.6-3.12 2.4-1.12 3.44-1.12 0.96 0.48 1.12-0.48 1.68-1.44 0.4 0.88 2.88-0.96 0.56 22 0.56-1.2 4.080 0.56 1.6 1.52 1.52 1.2 3.52h1.36l0.24-0.72 1.28-0.8-0.48-0.48 0.4-0.48 1.040 0.88 4.32-1.28-1.28-0.16 0.64-0.4 2 1.28 1.76-0.56 1.44 1.12 0.8-0.64-0.96-20.56 4.16-40.64-0.96-1.12h-1.84z"}));
}

MS.defaultProps = {"version":"1.1","width":"49","height":"80","viewBox":"0 0 49 80"};

module.exports = MS;

MS.default = MS;
